// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1wYKK","title":"ClientCherryInfo_title__2stj4","itemText":"ClientCherryInfo_itemText__2t8K9"};